import React from "react";
import {
  isDeviceType,
  reportDownload,
  reportDownloadApk,
  reportGoAppStore,
} from "../utils/tools";
import "./userAgentConponent.less";

class AgentMoreApp extends React.PureComponent {
  state = {
    downloadModalVisible: false,
  };

  componentDidMount() {
    this.goAppMarket();
  }

  componentWillUnmount() {
    this.setState({
      downloadModalVisible: false,
    });
  }

  goAppMarket() {
    let deviceType = isDeviceType();
    const { downLoanApkUrl } = this.props;

    let appPackageName = "tech.codeblock.okpeso"; //app包名
    let appMarketUrl = appPackageName;


    if(!['Huawei','OPPO','Vivo','Transsion'].includes(deviceType)){ // 插件没有设别出来 再走一遍自己判断
      let userAgent = navigator.userAgent.toLowerCase();
      if (/Huawei/i.test(userAgent) || /HONOR/i.test(userAgent)) {
        deviceType = "Huawei";
      } else if (/OPPO/i.test(userAgent)) {
        deviceType = "OPPO";
      } else if (/VIVO/i.test(userAgent)) {
        deviceType = "Vivo";
      } else if (/Transsion/i.test(userAgent)) {
        deviceType = 'Transsion';
      } else {
        deviceType = null;
      }


      if(!deviceType){
        if (window.location.pathname === '/redwlh') {
        deviceType = "Huawei";
        } else if (window.location.pathname === '/redwlo') {
          deviceType = "OPPO";
        } else if (window.location.pathname === '/redwlv') {
          deviceType = "Vivo";
        } else if (window.location.pathname === '/redwlc') {
          deviceType = 'Transsion';
        } else {
          deviceType = null;
        }
      }
    }

    switch (deviceType) {
      case "Huawei":
        appMarketUrl = "appmarket://details?id=" + appMarketUrl;
        break;
      case "OPPO":
        appMarketUrl = "oppomarket://details?packagename=" + appMarketUrl;
        break;
      case "Vivo":
        appMarketUrl = "vivomarket://details?id=" + appMarketUrl;
        break;
      case 'Transsion':
          appMarketUrl = 'hiapp://details?id=' + appMarketUrl;
          break;
      default:
        break;
    }


    console.log(appMarketUrl,'appMarketUrl');
    if (deviceType || ['/redwlo', '/redwlv', '/redwlc', '/redwlh'].includes(window.location.pathname)) {
      //弹提示框 去应用商城
      reportGoAppStore();
      this.setState({ downloadModalVisible: true });
      window.location.href = appMarketUrl;
    } else {
      reportDownload();
      //直接下载apk
      window.location.href = downLoanApkUrl;
    }
  }

  handleDownloadApk = () => {
    const { downLoanApkUrl } = this.props;
    window.location.href = downLoanApkUrl;
    reportDownloadApk();
    // 点击下载按钮 隐藏弹窗
    this.setState({ downloadModalVisible: false });
  };

  render() {
    const { downloadModalVisible } = this.state;
    return downloadModalVisible ? ( //走应用商城
      <div className={"userAgentModal"}>
        <div className={"userAgentMask"} />
        <div className={"content"}>
          <div className={"infoModal"}>
            <div className={"downloadDesc"}>
              Please install OKPeso in the app store, if you can't download and
              install it normally, please click the button below to install it
              directly
            </div>
            <div
              className={"download"}
              onClick={() => this.handleDownloadApk()}
            >
              download
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }
}
export default AgentMoreApp;
